import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import PickList from '../entities/pick-list';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import PickListPicking from '../entities/pick-list-picking';

interface PickListState extends ListState<PickList> {
	plIdsSelected: [];
	plPickings: Array<PickListPicking>;
	viewPlPicking: PickListPicking;
}
class PickListModule extends ListModule<PickListState, any, PickList> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<PickList>(),
		loading: false,
		plIds: new Array<number>(),
		plPickings: new Array<PickListPicking>(),
		viewPlPicking: new PickListPicking(),
	};
	actions = {
		async search(context: ActionContext<PickListState, any>, payload: any) {
			context.state.loading = true;
			let reponse = await Ajax.get('/api/services/app/PickList/Search', { params: payload.data });
			context.state.loading = false;
			let page = reponse.data.result as PageResult<PickList>;
			context.state.totalCount = page.totalCount;
			context.state.list = page.items;
		},
		async assign(context: ActionContext<PickListState, any>, payload: any) {
			const {
				data: { result },
			} = await Ajax.put('/api/services/app/PickList/Assign', payload.data);
			return result;
		},
		async view(context: ActionContext<PickList, any>, payload: any) {
			let reponse = await Ajax.get('/api/services/app/PickList/View?code=' + payload.data.code);
			return reponse.data.result as PickList;
		},
		async viewPlPicking(context: ActionContext<PickListState, any>, payload: any) {
			let reponse = await Ajax.get('/api/services/app/PickList/ViewPlPicking?code=' + payload.data.code);
			context.state.plPickings = reponse.data.result;
		},
		async getSoRequests(context: ActionContext<PickListState, any>, payload: any) {
			let reponse = await Ajax.get(`/api/services/app/PickList/${payload.data.id}/soRequests`);
			return reponse.data.result;
		},
	};
	mutations = {
		setCurrentPage(state: PickListState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: PickListState, pagesize: number) {
			state.pageSize = pagesize;
		},
		selectEmployee(state: PickListState, plIds: []) {
			state.plIdsSelected = plIds;
		},
		viewInfoPlPicking(state: PickListState, plPicking: PickListPicking) {
			state.viewPlPicking = plPicking;
		},
		setIsLoading(state: PickListState, isLoading: boolean) {
			state.loading = isLoading;
		},
	};
}
const pickListModule = new PickListModule();
export default pickListModule;
